import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IToDoDetailList } from "../toDoModel";
import moment from "moment";

export const getAllToDos = createAsyncThunk("ToDo/FindAllToDo", async () => {
  try {
    const response = await axiosApiInstance.post(
      `${API_URL}/ToDo/FindAllToDo`,
      {
        Title: "",
        Note: "",
      }
    );
    return response.data?.Data;
  } catch (error: any) {
    // ErrorToast(error?.response?.data?.Details || "Something went wrong");
    console.error("Error Fetching ToDos:", error);
    return Promise.reject({
      message: error?.response?.data?.Details || "Something went wrong",
    });
  }
});

export const createToDo = createAsyncThunk(
  "ToDo/InsertToDo",
  async (ToDoData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ToDo/InsertToDo`,
        ToDoData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating todo:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateToDo = createAsyncThunk(
  "ToDo/UpdateToDo",
  async (ToDoData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ToDo/UpdateToDo`,
        ToDoData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating todo:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteToDo = createAsyncThunk(
  "ToDo/DeleteToDo",
  async (ID: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ToDo/DeleteToDo`,
        { TitleGUID: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting todo:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getToDoByID = createAsyncThunk(
  "ToDo/FindByIDToDo",
  async (ID: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ToDo/FindByIDToDo`,
        { TitleGUID: ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result.Title,
        IsActive: result.IsActive,
        TitleGUID: result?.TitleGUID,
        Reminder: result?.Reminder
          ? moment(result?.Reminder, "YYYY-MM-DD").toDate()
          : "",
        ReminderTime: result?.ReminderTime
          ? moment(result?.ReminderTime, "HH:mm:ss").toDate()
          : "",
        Note: result?.Note,
        ToDoStatus: result?.ToDoStatus,
        ToDoAttachmentList: result?.ToDoAttachmentList || [],
      } as IToDoDetailList;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching todo:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveToDo = createAsyncThunk(
  "ToDo/FindAllActiveToDo",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/ToDo/FindAllActiveToDo`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching ToDos:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveToDo = createAsyncThunk(
  "ToDo/ActiveInActiveToDo",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ToDo/ActiveInActiveToDo`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive todo:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const insertToDoAttachment = createAsyncThunk(
  "ToDo/InsertToDoAttachment",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ToDo/InsertToDoAttachment`,
        formData
      );
      return response.data;
    } catch (error: any) {
      console.error("Error insert todo attachment:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteToDoAttachment = createAsyncThunk(
  "ToDo/DeleteToDoAttachment",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ToDo/DeleteToDoAttachment`,
        { ID: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting todo attachment:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateTaskStatus = createAsyncThunk(
  "ToDo/TaskDoneToDo",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ToDo/TaskDoneToDo`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating task status :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
